var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjectCreated = function SvgIconSubjectCreated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-subj-created",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-279.929 -84.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pages"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    transform: "translate(281.929 89.104)",
    fill: "#ebebeb",
    d: "M0 0h13v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M290.929 99.1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2Z",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M290.929 95.1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2Z",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "m291.713 91.2-.708 2.829 2.829-.708 3.887-3.887-2.121-2.119Z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M299.49 85.546a1.494 1.494 0 0 0-2.117 0l-.707.708 2.121 2.121.7-.7a1.5 1.5 0 0 0 .003-2.129Z",
    fill: "#ffb49d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "rotate(45 44.213 401.229)",
    fill: "#505050",
    d: "M0 0h3v1.501H0z"
  })))));
};
export { SvgIconSubjectCreated as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWJqLWNyZWF0ZWQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxyZWN0IGlkPSJhcmVhIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiNmMmYyZjIiIG9wYWNpdHk9IjAiLz4KICA8ZyBpZD0iaWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAxKSI+CiAgICA8ZyBpZD0icGFnZXMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODEuOTI5IC04NS4xMDQpIj4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV85IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA5IiB3aWR0aD0iMTMiIGhlaWdodD0iMTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4MS45MjkgODkuMTA0KSIgZmlsbD0iI2ViZWJlYiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF83MyIgZGF0YS1uYW1lPSJQYXRoIDczIiBkPSJNMjkwLjkyOSw5OS4xaC01YTEsMSwwLDAsMSwwLTJoNWExLDEsMCwwLDEsMCwyWiIgZmlsbD0iI2EwYTBhMCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF83NCIgZGF0YS1uYW1lPSJQYXRoIDc0IiBkPSJNMjkwLjkyOSw5NS4xaC01YTEsMSwwLDAsMSwwLTJoNWExLDEsMCwwLDEsMCwyWiIgZmlsbD0iI2EwYTBhMCIvPgogICAgPC9nPgogICAgPGcgaWQ9ImVkaXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODEuOTI5IC04NS4xMDQpIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfNzUiIGRhdGEtbmFtZT0iUGF0aCA3NSIgZD0iTTI5MS43MTMsOTEuMmwtLjcwOCwyLjgyOSwyLjgyOS0uNzA4LDMuODg3LTMuODg3TDI5NS42LDg3LjMxNVoiIGZpbGw9IiNmZmNlMDAiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfNzYiIGRhdGEtbmFtZT0iUGF0aCA3NiIgZD0iTTI5OS40OSw4NS41NDZhMS40OTQsMS40OTQsMCwwLDAtMi4xMTcsMGwtLjcwNy43MDgsMi4xMjEsMi4xMjEuNy0uN0ExLjUsMS41LDAsMCwwLDI5OS40OSw4NS41NDZaIiBmaWxsPSIjZmZiNDlkIi8+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTAiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDEwIiB3aWR0aD0iMyIgaGVpZ2h0PSIxLjUwMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjk2LjY2MSA4Ni4yNTQpIHJvdGF0ZSg0NSkiIGZpbGw9IiM1MDUwNTAiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";